<div class="tenant-rates-card rounded-3 bg-white border shadow-sm">

  <div class="row g-3 g-xl-4">
    <div class="col-12">
      <div class="text-uppercase tenant-rates-heading mb-3">Hourly rates by role / domain</div>

      <div class="tenant-rates-table-wrap">
        <table class="tenant-rates-table">
          <thead>
            <tr>
              <th>Role</th>
              <th class="text-end">Rate (R/hr)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="rate in rates" :key="rate.role">
              <td>{{ rate.role }}</td>
              <td class="text-end tenant-rates-amount">{{ rate.amount }}</td>
            </tr>
            <tr v-if="!rates.length">
              <td colspan="2" class="text-center text-secondary py-3">No hourly rates configured.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</div>
